<div class="estudiantes-list-container">
    <header>
      <h1>Lista de Estudiantes</h1>
    </header>
  
    <div class="filters-container">
      <form [formGroup]="searchForm" (ngSubmit)="filterEstudiantes()">
        <div class="filters-section">
          <h2>Filtros de búsqueda</h2>
          
          <div class="filters-grid">
            <!-- Datos personales -->
            <div class="filter-group">
              <label>Nro. Libreta</label>
              <div class="range-inputs">
                <input type="number" 
                      formControlName="nroLibretaDesde" 
                      placeholder="Desde"
                      min="1"
                      [class.error]="searchForm.get('nroLibretaDesde')?.invalid">
                <input type="number" 
                      formControlName="nroLibretaHasta" 
                      placeholder="Hasta"
                      min="1"
                      [class.error]="searchForm.get('nroLibretaHasta')?.invalid">
              </div>
              <small *ngIf="searchForm.get('nroLibretaDesde')?.invalid" class="error-text">
                {{ getFieldErrorMessage('nroLibretaDesde') }}
              </small>
              <small *ngIf="searchForm.get('nroLibretaHasta')?.invalid" class="error-text">
                {{ getFieldErrorMessage('nroLibretaHasta') }}
              </small>
            </div>
            
            <div class="filter-group">
              <label>Apellido</label>
              <input type="text" formControlName="apellido">
            </div>
            
            <div class="filter-group">
              <label>Nombre</label>
              <input type="text" formControlName="nombre">
            </div>
            
            <div class="filter-group">
              <label>Documento</label>
              <input type="text" formControlName="documento">
            </div>
            
            <div class="filter-group">
              <label>Fecha Nacimiento (Rango)</label>
              <div class="range-inputs">
                <input type="date" 
                      formControlName="fcNacimientoDesde"
                      [max]="TODAY"
                      [min]="MIN_BIRTH_DATE"
                      [class.error]="searchForm.get('fcNacimientoDesde')?.invalid">
                <input type="date" 
                      formControlName="fcNacimientoHasta"
                      [max]="TODAY"
                      [min]="MIN_BIRTH_DATE"
                      [class.error]="searchForm.get('fcNacimientoHasta')?.invalid">
              </div>
              <small *ngIf="searchForm.get('fcNacimientoDesde')?.invalid" class="error-text">
                {{ getFieldErrorMessage('fcNacimientoDesde') }}
              </small>
              <small *ngIf="searchForm.get('fcNacimientoHasta')?.invalid" class="error-text">
                {{ getFieldErrorMessage('fcNacimientoHasta') }}
              </small>
            </div>

            <div class="filter-group">
              <label>Localidad</label>
              <app-autocomplete-input
                [control]="localidadControl"
                [filterFunction]="filterLocalidades"
                placeholder="Buscar...">
              </app-autocomplete-input>
            </div>

            <div class="filter-group">
              <label>Provincia</label>
              <app-autocomplete-input
                [control]="provinciaControl"
                [filterFunction]="filterProvincias"
                placeholder="Buscar...">
              </app-autocomplete-input>
            </div>
            
            <!-- Datos de TKD -->
            <div class="filter-group">
              <label>Instructor</label>
              <select formControlName="idInstructor">
                <option value="">Todos</option>
                <option *ngFor="let instructor of instructores" [value]="instructor.id">
                  {{ instructor.nombre }} {{ instructor.apellido }}{{ !instructor.activo ? ' - INACTIVO' : '' }}
                </option>
              </select>
            </div>

            <div class="filter-group">
                <label>Centro de Entrenamiento</label>
                <select formControlName="idCentroEntrenamiento" id="idCentroEntrenamiento">
                  <option value="">Todos</option>
                  <ng-container *ngFor="let centro of centros">
                    <option [value]="centro.id" [ngClass]="{'inactive-option': !centro.activo}">
                      {{ centro.nombre }} {{ !centro.activo ? ' - INACTIVO' : '' }}
                    </option>
                  </ng-container>
                </select>
              </div>
            
            <div class="filter-group">
              <label>Fecha Inicio (Rango)</label>
              <div class="range-inputs">
                <input type="date" 
                      formControlName="fcInicioDesde"
                      [max]="TODAY"
                      [class.error]="searchForm.get('fcInicioDesde')?.invalid">
                <input type="date" 
                      formControlName="fcInicioHasta"
                      [max]="TODAY"
                      [class.error]="searchForm.get('fcInicioHasta')?.invalid">
              </div>
              <small *ngIf="searchForm.get('fcInicioDesde')?.invalid" class="error-text">
                {{ getFieldErrorMessage('fcInicioDesde') }}
              </small>
              <small *ngIf="searchForm.get('fcInicioHasta')?.invalid" class="error-text">
                {{ getFieldErrorMessage('fcInicioHasta') }}
              </small>
            </div>
            
            <div class="filter-group">
                <label>Graduación</label>
                <select formControlName="idGraduacion">
                    <option value="">Todos</option>
                    <option *ngFor="let graduacion of graduaciones" [value]="graduacion.id">
                    {{ graduacion.nombre }}
                    </option>
                </select>
            </div>
            
            <div class="filter-group">
              <label>Fecha Último Examen (Rango)</label>
              <div class="range-inputs">
                <input type="date" 
                      formControlName="fcUltimoExamenDesde"
                      [max]="TODAY"
                      [class.error]="searchForm.get('fcUltimoExamenDesde')?.invalid">
                <input type="date" 
                      formControlName="fcUltimoExamenHasta"
                      [max]="TODAY"
                      [class.error]="searchForm.get('fcUltimoExamenHasta')?.invalid">
              </div>
              <small *ngIf="searchForm.get('fcUltimoExamenDesde')?.invalid" class="error-text">
                {{ getFieldErrorMessage('fcUltimoExamenDesde') }}
              </small>
              <small *ngIf="searchForm.get('fcUltimoExamenHasta')?.invalid" class="error-text">
                {{ getFieldErrorMessage('fcUltimoExamenHasta') }}
              </small>
            </div>

            <div class="filter-group">
              <label>Búsquedas especiales</label>
              <select formControlName="busquedaEspecial">
                <option value="">Ninguna</option>
                <option value="DANES">DANES</option>
                <option value="GUPS">GUPS</option>
                <option value="INSTRUCTORES">Instructores</option>
                <option value="SIN_EXAMENES">Sin exámenes</option>
                <option value="INFANTILES">Infantiles (hasta 12 años)</option>
                <option value="JUVENILES">Juveniles (13~17 años)</option>
                <option value="ADULTOS">Adultos (18~34 años)</option>
                <option value="VETERANOS">Veteranos (desde 35 años)</option>
              </select>
            </div>
          </div>
          
          <div class="filter-buttons">
            <button type="submit" 
                    class="btn-search" 
                    [disabled]="hasValidationErrors()">
              <i class="fas fa-search"></i> Buscar
            </button>
            <button type="button" class="btn-reset" (click)="resetFilters()">
              <i class="fas fa-times"></i> Limpiar filtros
            </button>
          </div>
        </div>
      </form>
    </div>
  
    <div class="results-container">
      <div *ngIf="loading" class="loading-spinner">
        <i class="fas fa-spinner fa-spin"></i> Cargando...
      </div>
      
      <div *ngIf="errorMessage" class="error-message">
        <i class="fas fa-exclamation-triangle"></i> {{ errorMessage }}
      </div>
      
      <div class="results-header">
        <div class="results-info">
          <div>Se encontraron {{ filteredEstudiantes.length }} estudiantes</div>
          <div *ngIf="filteredEstudiantes.length > 0" class="pagination-info">
            Mostrando {{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, filteredEstudiantes.length) }} de {{ filteredEstudiantes.length }}
          </div>
          <div></div> <!-- Empty div for grid spacing -->
        </div>
        
        <div class="sorting-controls">
          <label>Ordenar por:</label>
          <select [(ngModel)]="sortBy" (change)="onSortChange(sortBy)">
            <option value="nroLibreta">Nro. Libreta</option>
            <option value="apellido">Apellido</option>
            <option value="nombre">Nombre</option>
            <option value="documento">Documento</option>
            <option value="fcNacimiento">Fecha Nacimiento</option>
            <option value="nacionalidad">Nacionalidad</option>
            <option value="localidad">Localidad</option>
            <option value="provincia">Provincia</option>
            <option value="instructor">Instructor</option>
            <option value="centroEntrenamiento">Centro de Entrenamiento</option>
            <option value="fcInicio">Fecha Inicio</option>
            <option value="graduacion">Graduación</option>
            <option value="fcUltimoExamen">Fecha Último Examen</option>
          </select>
          
          <button 
            class="sort-toggle-btn" 
            (click)="onSortChange(sortBy)"
            [title]="sortOrder === 'asc' ? 'Cambiar a descendente' : 'Cambiar a ascendente'">
            <i class="fas" [ngClass]="sortOrder === 'asc' ? 'fa-sort-amount-up' : 'fa-sort-amount-down'"></i>
          </button>
        </div>
      </div>
      
      <!-- Pagination controls (top) -->
      <div *ngIf="totalPages > 1 && !loading" class="pagination-controls">
        <button 
          class="pagination-button" 
          [disabled]="currentPage === 1"
          (click)="goToPage(1)">
          <i class="fas fa-angle-double-left"></i>
        </button>
        <button 
          class="pagination-button" 
          [disabled]="currentPage === 1"
          (click)="previousPage()">
          <i class="fas fa-angle-left"></i>
        </button>
        
        <div class="page-numbers">
          <button 
            *ngFor="let page of getPageNumbers()"
            class="pagination-button" 
            [class.active]="page === currentPage"
            (click)="goToPage(page)">
            {{ page }}
          </button>
        </div>
        
        <button 
          class="pagination-button" 
          [disabled]="currentPage === totalPages"
          (click)="nextPage()">
          <i class="fas fa-angle-right"></i>
        </button>
        <button 
          class="pagination-button" 
          [disabled]="currentPage === totalPages"
          (click)="goToPage(totalPages)">
          <i class="fas fa-angle-double-right"></i>
        </button>
      </div>
      
      <div class="estudiantes-grid">
        <app-estudiante-card 
          *ngFor="let estudiante of paginatedEstudiantes"
          [estudiante]="estudiante"
          (viewDetail)="onViewDetail($event)">
        </app-estudiante-card>
        
        <div *ngIf="filteredEstudiantes.length === 0 && !loading" class="no-results">
          No se encontraron estudiantes con los filtros aplicados
        </div>
      </div>
      
      <!-- Pagination controls (bottom) -->
      <div *ngIf="totalPages > 1 && !loading" class="pagination-controls">
        <button 
          class="pagination-button" 
          [disabled]="currentPage === 1"
          (click)="goToPage(1)">
          <i class="fas fa-angle-double-left"></i>
        </button>
        <button 
          class="pagination-button" 
          [disabled]="currentPage === 1"
          (click)="previousPage()">
          <i class="fas fa-angle-left"></i>
        </button>
        
        <div class="page-numbers">
          <button 
            *ngFor="let page of getPageNumbers()"
            class="pagination-button" 
            [class.active]="page === currentPage"
            (click)="goToPage(page)">
            {{ page }}
          </button>
        </div>
        
        <button 
          class="pagination-button" 
          [disabled]="currentPage === totalPages"
          (click)="nextPage()">
          <i class="fas fa-angle-right"></i>
        </button>
        <button 
          class="pagination-button" 
          [disabled]="currentPage === totalPages"
          (click)="goToPage(totalPages)">
          <i class="fas fa-angle-double-right"></i>
        </button>
      </div>
    </div>
  </div>
  
  <!-- Modal para detalle de estudiante -->
  <div class="modal-overlay" *ngIf="showDetail" (click)="onCloseDetail()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <button class="modal-close" (click)="onCloseDetail()">
        <i class="fas fa-times"></i>
      </button>
      <app-estudiante-detail 
        [estudiante]="selectedEstudiante"
        (cancelEdit)="onCloseDetail()">
      </app-estudiante-detail>
    </div>
  </div>